import React from "react";
import styles from "./CreateListingPage.module.css"
import CreateListingForm from "../../components/CreateListingForm/CreateListingForm";
import NavBar from "../../components/NavBar/NavBar";

export default function CreateListingPage() {
    return (
 
        <div>
        <NavBar/>
        <div className={styles.pageWrapper}>
            <div className={styles.contentBox}>
                <h1 className={styles.title}>Create a New Listing</h1>
                <CreateListingForm/>
                </div>
            </div>
        </div>
       
    )
}